import { render, staticRenderFns } from "./AddCourseware.vue?vue&type=template&id=7a481838&scoped=true"
import script from "./AddCourseware.vue?vue&type=script&lang=js"
export * from "./AddCourseware.vue?vue&type=script&lang=js"
import style0 from "./AddCourseware.vue?vue&type=style&index=0&id=7a481838&prod&lang=less"
import style1 from "./AddCourseware.vue?vue&type=style&index=1&id=7a481838&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a481838",
  null
  
)

export default component.exports